var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from "react-redux";
var GridResponse = function (_a) {
    var main = _a.main, sub = _a.sub, _b = _a.className, className = _b === void 0 ? '' : _b;
    var _c = useState(0), windowSize = _c[0], setWindowSize = _c[1];
    var isPopUp = useSelector(function (state) { return state.product.isPopUp; });
    useEffect(function () {
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    var handleResize = function () {
        var size = window.innerWidth;
        setWindowSize(size);
    };
    return (React.createElement(Container, { className: className },
        React.createElement(Main, null, main),
        windowSize > 1209 && !isPopUp && React.createElement(Side, null, sub)));
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    width: 1190px;\n    margin: 0 auto;\n\n    @media (max-width: 1209px) {\n        & {width: 950px}\n    }\n"], ["\n    display: flex;\n    width: 1190px;\n    margin: 0 auto;\n\n    @media (max-width: 1209px) {\n        & {width: 950px}\n    }\n"])));
var Main = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 950px;\n"], ["\n    width: 950px;\n"])));
var Side = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0 0 0 20px;\n    width: 220px;\n"], ["\n    margin: 0 0 0 20px;\n    width: 220px;\n"])));
export default GridResponse;
var templateObject_1, templateObject_2, templateObject_3;



//////////////////
// WEBPACK FOOTER
// ./src/detail/layouts/grid_response/index.tsx
// module id = 174
// module chunks = 0